import { useAppSelector } from '@verantos-dev/app-state-base';

import {
  selectCohortBuilderItemIdsToNamesMap,
  selectInUseCohortBuilderItemsMap,
} from '../selectors/cohortBuilderWorkflowSelectors';
import { getInUseCohortBuilderNamesForId } from '../utils/getInUseCohortBuilderNamesForId';

export const useCohortBuilderItemIsInUse = (id: string | undefined): boolean => {
  const inUseCohortBuilderItemsMap = useAppSelector(selectInUseCohortBuilderItemsMap);
  const cohortBuilderItemIdsToNamesMap = useAppSelector(selectCohortBuilderItemIdsToNamesMap);
  const inUseItems =
    id &&
    getInUseCohortBuilderNamesForId(id, inUseCohortBuilderItemsMap, cohortBuilderItemIdsToNamesMap);
  return !!inUseItems && inUseItems.length > 0;
};
